import { c as _c } from "react/compiler-runtime";
import { NO_TRANSLATE_CLASS, Tooltip } from "@flat-ui";
import { PROJECTS_SORT_BY_MAP } from "@components/projects/projects-sort-constants";
import { ProjectDateTooltip } from "@components/common/project-card/project-date-tooltip";
import { useDateTime } from "@hooks/use-date-time";
import { UiUtils } from "@stellar/utils";
import { getProjectDateBySort, getProjectDateLabel } from "@utils/project-utils";
/**
 * The project date matching the sort field, e.g. "Last updated: Oct 12, 2026", with all the
 * project dates in a tooltip. Shown above the project name in the project cards.
 */
export function ProjectCardDate(t0) {
  const $ = _c(14);
  const {
    project,
    sortBy
  } = t0;
  const {
    formatDateWithTooltip
  } = useDateTime();
  const sortField = PROJECTS_SORT_BY_MAP[sortBy].field;
  let t1;
  if ($[0] !== formatDateWithTooltip || $[1] !== project || $[2] !== sortField) {
    const projectDate = getProjectDateBySort(project, sortField);
    t1 = projectDate ? formatDateWithTooltip(projectDate).displayDate : UiUtils.DASH;
    $[0] = formatDateWithTooltip;
    $[1] = project;
    $[2] = sortField;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const formattedDate = t1;
  let t2;
  if ($[4] !== project) {
    t2 = <ProjectDateTooltip project={project} />;
    $[4] = project;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] !== sortField) {
    t3 = getProjectDateLabel(sortField);
    $[6] = sortField;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] !== formattedDate) {
    t4 = <span className={NO_TRANSLATE_CLASS}>: {formattedDate}</span>;
    $[8] = formattedDate;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  let t5;
  if ($[10] !== t2 || $[11] !== t3 || $[12] !== t4) {
    t5 = <Tooltip title={t2}>{t3}{t4}</Tooltip>;
    $[10] = t2;
    $[11] = t3;
    $[12] = t4;
    $[13] = t5;
  } else {
    t5 = $[13];
  }
  return t5;
}